import React from "react";

import { useHistory } from "react-router-dom";

// Components imports
import Button from "../Button";

// Scss imports
import css from "./PapersNavigation.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  getAllPagePapers,
  getCertainPagePapers,
} from "../../../redux/actions/papersActions";

interface PapersNavigationProps {
  buttonText: string;
  setPapersData: Function;
  allPagePapers: [];
  certainPagePapers: [];
  setPapers: Function;
  setButtonText: Function;
  setPapersTitle: Function;
  setActivePage: Function;
  activePage: number;
  pageLimit: number;
}

const PapersNavigation: React.FC<PapersNavigationProps> = ({
  buttonText,
  setPapersData,
  allPagePapers,
  certainPagePapers,
  setPapers,
  setButtonText,
  setPapersTitle,
  setActivePage,
  activePage,
  pageLimit,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <div className={css.container}>
      <div className={css.buttonWrapper}>
        <Button
          text={buttonText}
          onButtonClickHandler={() => {
            if (buttonText === "Прикажи све") {
              setPapers("all");
              setButtonText("Прикажи тренутну");
              setPapersTitle("Деловодник за све године");
              setActivePage(1);
              dispatch(getAllPagePapers(activePage, pageLimit, ""));
            } else if (buttonText === "Прикажи тренутну") {
              setPapers("lastYear");
              setButtonText("Прикажи све");
              setPapersTitle(
                `Деловодник за ${new Date().getFullYear()} годину`
              );
              dispatch(getAllPagePapers(activePage, pageLimit, ""));
              setActivePage(1);
            }
          }}
          type="papersNavigationButton"
        />
      </div>
      <div className={css.buttonWrapper}>
        <Button
          text="Унеси документа"
          onButtonClickHandler={() => {
            history.push("/record-book");
          }}
          type="papersNavigationButton"
        />
      </div>
      <div className={css.buttonWrapper}>
        <Button
          text="Архивирај"
          onButtonClickHandler={() => {
            history.push("/not-archived-papers");
          }}
          type="papersNavigationButton"
        />
      </div>
      <div className={css.buttonWrapper}>
        <Button
          text="Додај архиву"
          onButtonClickHandler={() => {
            history.push("/add-archive");
          }}
          type="papersNavigationButton"
        />
      </div>
    </div>
  );
};

export default PapersNavigation;
